/**
 * uuid v4 для ключей идемпотентности и следа раздачи.
 *
 * ⚠️ `crypto.randomUUID` есть только в защищённом контексте, а дев-сервер
 * слушает LAN по http: тот же приём и та же причина, что у идентификатора
 * слайда (`features/board/slides.ts`). Запасной путь обязан давать именно
 * uuid, а не просто 32 шестнадцатеричных знака: схема запроса на сервере
 * требует uuid, и «почти уникальная строка» получила бы `invalid_body`.
 */
export function newId(): string {
  if (typeof crypto.randomUUID === "function") return crypto.randomUUID();
  const bytes = Array.from(crypto.getRandomValues(new Uint8Array(16)));
  bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40;
  bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80;
  const hex = bytes.map((b) => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
